<template>
  <ValidationObserver v-slot="{ valid }">
    <unicom-filtro-v2
      titulo="Filtrar PTU"
      :value="mostrar"
      @limpar-filtro="limpar"
      @fechar="fecharFiltro"
      @filtrar="filtrar"
      :bloquearBotaoFiltro="!valid"
    >
      <div slot="corpo-subtitulo">
        Selecione os dados desejados,<br />
        depois clique em FILTRAR.
      </div>
      <div slot="corpo-filtro" style="margin: 0 32px">
        <unicom-linha espacamento class="fonte-secundaria espacamento-filtro">
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Tipo do endereço"
              titulo="Tipo do endereço"
              v-model="objetoFiltro.tipoEndereco.descricao"
              @index="
                index =>
                  selecionarChave(index, 'tipoEndereco', listaTipoEndereco)
              "
              :items="listaTipoEndereco.map(e => e.descricao)"
            />
          </unicom-coluna>
          <unicom-coluna sm="12" class="linha-embaixo">
            <unicom-autocomplete
              mostrarIconeExcluir
              colorPlaceholder="#9E9E9E"
              placeholder="Cidade   "
              titulo="Cidade    "
              v-model="objetoFiltro.cidade.descricao"
              @index="index => selecionarChave(index, 'cidade', listaCidades)"
              :items="listaCidades.map(e => e.valor)"
            />
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-filtro-v2>
  </ValidationObserver>
</template>

<script>
/* eslint-disable */
import FiltroMixin from "@/shared/mixin/FiltroMixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import TabelaEnderecoService from "../TabelaEnderecoService";

export default {
  mixins: [FiltroMixin, TabelaEnderecoService],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: {
    listaTipoEndereco: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      listaCidades: [],
      objetoFiltro: {},
      objetoFiltroVazio: {
        tipoEndereco: {
          chave: "",
          descricao: ""
        },
        cidade: {
          chave: "",
          descricao: ""
        }
      }
    };
  },
  beforeMount() {
    this.objetoFiltro = JSON.parse(JSON.stringify(this.objetoFiltroVazio));
  },

  methods: {
    filtrar() {
      const {
        tipoEndereco: { chave: chaveEndereco },
        cidade: { chave: chaveCidade }
      } = this.objetoFiltro;

      const objetoFiltro = {
        tipoEndereco: chaveEndereco,
        codigoMunicipio: chaveCidade
      };

      this.$emit("filtrar", objetoFiltro);
      this.$emit("filtroPuro", this.objetoFiltro);
    },

    inicializarCidades() {
      if (this.listaCidades.length > 0) return Promise.resolve();

      return new Promise((resolve, reject) => {
        this.getCidades()
          .then(res => {
            this.listaCidades = res.data;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
  },

  watch: {
    mostrar(newValue) {
      if (newValue) {
        this.$store.commit("setLoadingModal", true);
        this.inicializarCidades()
          .finally(() => {
        this.$store.commit("setLoadingModal", false);
          })
      }
    }
  }
};
</script>

<style lang="scss">
.espacamento-filtro {
  .col-12 {
    padding-top: 24px;
  }
}
</style>